/**
 * Per-operator canvas preferences (localStorage; same pattern as the `ol.theme` key in uiSlice).
 * Storage failure is non-fatal — the canvas just runs on defaults.
 */
const MINIMAP_KEY = 'ol.designer.minimap';

/** Minimap visibility preference. Default ON (spatial orientation on large flows). */
export function loadMinimapVisible(): boolean {
  try {
    return localStorage.getItem(MINIMAP_KEY) !== 'off';
  } catch {
    return true;
  }
}

export function saveMinimapVisible(visible: boolean): void {
  try {
    localStorage.setItem(MINIMAP_KEY, visible ? 'on' : 'off');
  } catch {
    /* storage unavailable — non-fatal */
  }
}
